/* Gedeelde helpers voor de agenda */
export const STATUS_STYLE = {
  scheduled: "bg-sky-500/15 text-sky-700 dark:text-sky-300 border-sky-500/30",
  confirmed: "bg-violet-500/15 text-violet-700 dark:text-violet-300 border-violet-500/30",
  in_service: "bg-amber-500/20 text-amber-700 dark:text-amber-300 border-amber-500/40",
  completed: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/30",
  cancelled: "bg-rose-500/10 text-rose-600 dark:text-rose-300 border-rose-500/30 line-through opacity-70",
};
export const STATUS_BAR = { scheduled: "bg-sky-500", confirmed: "bg-violet-500", in_service: "bg-amber-500", completed: "bg-emerald-500", cancelled: "bg-rose-400" };
export const STATUS_FLOW = ["scheduled", "confirmed", "in_service", "completed"];
export const HOURS = Array.from({ length: 12 }, (_, i) => 7 + i); // 07:00–18:00
export const SERVICE_PRESETS = ["Kleine beurt", "Grote beurt", "Remmen", "Banden wisselen", "Diagnose / storing", "Keuring voorbereiding", "Airco service", "Distributie", "Koppeling", "Olie verversen"];

export const isoDay = (d) => { const o = d.getTimezoneOffset(); return new Date(d.getTime() - o * 60000).toISOString().slice(0, 10); };
export const isoLocal = (d) => { const o = d.getTimezoneOffset(); return new Date(d.getTime() - o * 60000).toISOString().slice(0, 16); };
export const localDate = (iso) => new Date(iso);
export const hm = (iso) => localDate(iso).toTimeString().slice(0, 5);
export const dayKey = (iso) => isoDay(localDate(iso));
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const startOfWeek = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return x; };
export const sameDay = (a, b) => isoDay(a) === isoDay(b);
export const minutesFromStart = (iso) => { const d = localDate(iso); return (d.getHours() - HOURS[0]) * 60 + d.getMinutes(); };

export function monthCells(year, month) {
  const first = new Date(year, month, 1);
  const startDay = (first.getDay() + 6) % 7;
  const days = new Date(year, month + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(addDays(first, i - startDay));
  for (let d = 1; d <= days; d++) cells.push(new Date(year, month, d));
  while (cells.length % 7) cells.push(addDays(cells[cells.length - 1], 1));
  return cells;
}

export const EMPTY_FORM = (at) => ({ customer_id: "", vehicle_id: "", mechanic_id: "", scheduled_at: at || isoLocal(new Date(Date.now() + 3600e3)), duration_min: 60, service_type: "", notes: "" });
